var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessagesBubbles = function SvgMessagesBubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.5 5.674c.59.19 1 .752 1 1.398v2.857c0 .758-.565 1.4-1.32 1.462a33 33 0 0 1-.68.048V13.5l-2-2a33 33 0 0 1-2.68-.109 1.4 1.4 0 0 1-.55-.161m6.23-5.556a1.4 1.4 0 0 0-.317-.063 32.4 32.4 0 0 0-5.366 0c-.754.062-1.317.704-1.317 1.461v2.857c0 .558.307 1.054.77 1.301m6.23-5.556v-1.25c0-1.08-.768-2.017-1.84-2.156a32.3 32.3 0 0 0-8.32 0c-1.072.14-1.84 1.076-1.84 2.157v4.15c0 1.081.768 2.018 1.84 2.157q.577.075 1.16.13V14l2.77-2.77"
  })));
};
export { SvgMessagesBubbles as ReactComponent };
export default __webpack_public_path__ + "79b91653c3d875e8a7bc18350cf9f617.svg";